import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { FaDiscord } from '@react-icons/all-files/fa/FaDiscord'
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter'

import Navigation from './navigation'

const Header = () => {
    return (
        <header className="absolute top-2 w-full z-10">
            <div className="container mx-auto md:p-4">
                <div className="flex items-center justify-between p-4">
                    <div className="justify-self-start select-none">
                        <Link to="/">
                            <StaticImage src="../../images/logo.png" alt="Top Dog Beach Club" width={130} placeholder="tracedSVG" />
                        </Link>
                    </div>

                    <div className="justify-self-end self-center">
                        <Navigation />
                    </div>

                    <div className="hidden lg:block bg-gray-100 rounded-full shadow-lg py-4 px-6">
                        <ul className="flex">
                            <li className="mr-3">
                                <a
                                    href="https://twitter.com/topdogstudios"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    title="Follow us on Twitter"
                                >
                                    <FaTwitter size="18pt" className="inline text-blue-400 hover:text-blue-500 levitate" />
                                </a>
                            </li>

                            <li className="ml-3">
                                <a
                                    href="https://discord.gg/topdogbeachclub"
                                    target="_blank"
                                    rel="noreferrer noopener"
                                    title="Join the discussion on Discord"
                                >
                                    <FaDiscord size="18pt" className="inline text-indigo-500 hover:text-indigo-600 levitate" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header
